import styles from './HeaderWrapperV8.module.scss';

import clsx from 'clsx';
import React from 'react';

import { useDraggableRow } from '../../../row-render/hooks/use-draggable-row';

interface HeaderWrapperV8Props {
  children?: React.ReactNode;
  className?: string;
}

export function HeaderWrapperV8(props: HeaderWrapperV8Props) {
  const { draggable } = useDraggableRow();
  const className = clsx(styles.root, props.className, {
    [styles.draggableHeader]: draggable,
  });

  return <div className={className}>{props.children}</div>;
}
